import { Grid } from '@material-ui/core';
import { ContaBancariaForm } from 'app/main/pessoa/ContaBancaria';
import React from 'react';

const TabContaBancariaVendedor = ({ onChange, onBlur, values, errors, touched, submitCount }) => {
  // nos outros Form tá usando o context do formik, esse recebe "handleChange", e os value
  return (
    <Grid container spacing={3}>
      <ContaBancariaForm
        handleChange={onChange}
        required={false}
        onBlur={onBlur}
        touched={touched}
        errors={errors}
        contaBancaria={values?.contaBancaria}
        contaDescricao={values?.descricao}
      />
    </Grid>
  );
};

export default TabContaBancariaVendedor;
